import { directUploadAxios } from "@src/initializers/axios";
import { withCriticalRetry } from "@utils/apiWrapper";
import axios from "axios";
import { API_BASE_URL_V2 } from "initializers/constants";
export const getDirectUploadURL = ({ ciBuildId, historyId }, payload) => withCriticalRetry(() => axios.post(`${API_BASE_URL_V2}/reporter/runs/${ciBuildId}/test_entities/${historyId}/direct_uploads`, { blob: payload }), { additionalRetryStatusCodes: [422] });
export const directUpload = (data, { url, headers }, options) => withCriticalRetry(() => directUploadAxios.put(url, data, {
    ...options,
    headers,
    timeout: 0,
}));
//# sourceMappingURL=directUpload.js.map